import { createClient, ConnectError, Code, type Interceptor } from "@connectrpc/connect";
import { createConnectTransport } from "@connectrpc/connect-web";
import { AppService } from "./gen/app_pb";
import { PreviewService } from "./gen/preview_pb";
import { accessToken, sessionSignal, sessionSnapshot } from "./session";
import { rpcBaseUrl } from "./config";

const auth: Interceptor = (next) => async (request) => {
  const generation = sessionSnapshot().generation;
  const signal = AbortSignal.any([request.signal, sessionSignal()]);
  const token = await accessToken();
  if (generation !== sessionSnapshot().generation || signal.aborted)
    throw new ConnectError("Session changed", Code.Canceled);
  request.header.set("Authorization", `Bearer ${token}`);
  let response;
  try {
    response = await next({ ...request, signal });
  } catch (error) {
    if (ConnectError.from(error).code !== Code.Unauthenticated || signal.aborted) throw error;
    const refreshed =
      sessionSnapshot().tokens?.access_token !== token
        ? await accessToken()
        : await accessToken(true);
    request.header.set("Authorization", `Bearer ${refreshed}`);
    response = await next({ ...request, signal });
  }
  if (generation !== sessionSnapshot().generation)
    throw new ConnectError("Session changed", Code.Canceled);
  return response;
};
const transport = createConnectTransport({
  baseUrl: rpcBaseUrl,
  useBinaryFormat: true,
  interceptors: [auth],
});
export const appRpc = createClient(AppService, transport);
export const previewRpc = createClient(PreviewService, transport);
